import { Resources } from 'constants/resources';

import { useOrderAdjustmentIndex } from 'pages/OrderAdjustments/hooks/useOrderAdjustmentIndex';
import { OrderAdjustmentsFormValues } from 'pages/OrderAdjustments/hooks/useOrderAdjustmentsForm';
import { useGetOne, useRecordContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { LinearProgress } from 'shared/mui/LinearProgress/LinearProgress';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { Currency } from 'types/embedded/currency';
import { Order } from 'types/embedded/order';
import { formatCurrency } from 'utils';

type Props = Omit<FunctionFieldProps, 'render'>;

export const OrderAdjustmentsAmountField: React.FC<Props> = (props) => {
  const { watch } = useFormContext<OrderAdjustmentsFormValues>();

  const record = useRecordContext();
  const { data: currency, isLoading } = useGetOne<Currency>(
    Resources.Currencies,
    { id: record?.currency?.['@id'] },
    { enabled: !!record?.currency },
  );

  const recordIndex = useOrderAdjustmentIndex(record?.id);
  const newAmount = watch(`orderAdjustments.${recordIndex}.newAmount`);

  if (isLoading) {
    return <LinearProgress />;
  }

  return (
    <FunctionField
      render={(record: Order) => {
        if (!newAmount && record.amount) {
          return (
            <Typography variant="body2">
              {formatCurrency(record.amount as Intl.StringNumericLiteral)}{' '}
              <Typography color="primary.main" component="span" fontSize={14}>
                {currency?.alphaCode}
              </Typography>
            </Typography>
          );
        }
        return (
          <Box>
            <Typography color="success.main" variant="body2">
              {formatCurrency(newAmount ?? 0)} {currency?.alphaCode}
            </Typography>
            <Typography sx={{ textDecoration: 'line-through' }} variant="body2">
              {formatCurrency(record.amount as Intl.StringNumericLiteral)}{' '}
              <Typography color="primary.main" component="span" fontSize={14}>
                {currency?.alphaCode}
              </Typography>
            </Typography>
          </Box>
        );
      }}
      {...props}
    />
  );
};
